import { render, staticRenderFns } from "./violationEventDetails.vue?vue&type=template&id=41369d90&scoped=true"
import script from "./violationEventDetails.vue?vue&type=script&lang=js"
export * from "./violationEventDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41369d90",
  null
  
)

export default component.exports